import { chakra } from '@stockx/ui';

export const NavBarSearchWrapper = chakra('div', {
  baseStyle: {
    display: { base: 'none', md: 'block' },
  },
});
